import { HttpResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeprecatedConfirmationDialogComponent } from '@app/components';
import { CustomReportQuery } from '@app/models/reporting/custom-report-query.model';
import { MenuColumnEvent } from '@app/modules/table/interfaces/menu-column-event.interface';
import { FileHelperService } from '@app/services';
import { Query } from '@reporting/services/queries/query';
import { CustomReportsTable } from '@reporting/services/tables/custom-reports-table/custom-reports.table';
import { CustomReportingService } from '../../services/custom-reporting.service';
import { ReportingModuleMenuService } from '../../services/reporting-module-menu.service';
@Component({
    templateUrl: './custom-reports.view.html',
    styleUrls: ['./custom-reports.style.scss'],
})
export class CustomReportsView {
    isLoading = true;

    @ViewChild('confirmDeleteCustomReportDialog', { static: true })
    confirmDeleteCustomReportDialog: DeprecatedConfirmationDialogComponent;

    constructor(
        public table: CustomReportsTable,
        private router: Router,
        private route: ActivatedRoute,
        private customReportingService: CustomReportingService,
        private fileService: FileHelperService,
        public menuService: ReportingModuleMenuService
    ) {
        this.table.onLoading.subscribe((isLoading) => (this.isLoading = isLoading));
        this.table.reload();
    }

    async onTableMenuEvent(event: MenuColumnEvent): Promise<void> {
        const eventType = event.menuItem.event;
        const customReportQuery = event.data as CustomReportQuery;
        const exportQuery = new Query('custom', customReportQuery.id.toString());

        switch (eventType) {
            case 'exportAsCsv':
                this.exportReport(exportQuery, 'csv');
                break;

            case 'exportAsXlxs':
                this.exportReport(exportQuery, 'xlsx');
                break;
            case 'delete':
                this.onDelete(customReportQuery);
                break;
            case 'edit':
                this.router.navigate([String(customReportQuery.id)], { relativeTo: this.route });
                break;
        }
    }

    onDelete(customReportQuery: CustomReportQuery): void {
        this.setCustomReportDeleteDialogHeader(customReportQuery);

        this.confirmDeleteCustomReportDialog.show().then((confirm) => {
            if (!confirm) {
                return;
            }

            this.isLoading = true;
            this.customReportingService.deleteCustomReport(customReportQuery).then(() => {
                this.table.reload();
                this.isLoading = false;
            });
        });
    }

    private setCustomReportDeleteDialogHeader(customReportQuery: CustomReportQuery): void {
        this.confirmDeleteCustomReportDialog.header = `Delete ${customReportQuery.name}?`;
    }

    private exportReport(exportQuery: Query, contentType: string): Promise<boolean> {
        let encode = '';
        switch (contentType) {
            case 'csv':
                encode = 'text/csv';
                break;
            case 'xlsx':
                encode = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                break;
            default:
                break;
        }
        return exportQuery.fetchResponse(encode).then((response: HttpResponse<Blob>) => {
            return this.fileService.saveFileFromResponse(response, 'report-export.' + contentType);
        });
    }
}
